export const mimeTypes = {
    IMAGE: [
        "image/jpeg", 
        "image/jpg",
        "image/png"
    ],
    VIDEO: [    
        "video/quicktime",
        "video/mp4",
        "video/3gpp",
        "video/x-msvideo",
        "video/x-ms-wmv"
    ],
    AUDIO: [
        "audio/mp3",
        "audio/mp4",
        "audio/wav",
        "audio/ogg",
        "audio/mpeg"
    ],
    FILES: [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ]
}